import { AxiosResponse } from 'axios';
/* eslint-disable @typescript-eslint/camelcase */
import {
  fetchFailure,
  fetchRequests,
  fetchSuccess,
} from '../../redux/personalInfo.actions';
import store from '../../../../redux/store';

import { PersonProperties, LeadProperties } from './savePersonInfo.types';
import makeRequests from '../../../../services/http/http.makeRequests';
import getQueryParams from '../../../../../shared/utilities/queryParams/getQueryParams';

const SavePerson = (callback: () => void): void => {
  const dispatch = store.dispatch;
  const state = store.getState();
  const queryParams = getQueryParams();
  const personalInfo = state.personalInfo.person;
  const leadId = localStorage.getItem('lead_id');

  const updateLeadStatus = (id: string): void => {
    const endpoint = `leads/${id}`;
    const payload = {
      status: 'CHS_PERSON_COMPLETED',
    };
    dispatch(
      fetchRequests({
        isLoading: true,
      }),
    );
    makeRequests(
      endpoint,
      'PUT',
      payload,
      () => {
        dispatch(
          fetchSuccess({
            isLoading: false,
          }),
        );
        callback();
      },
      () =>
        dispatch(
          fetchFailure({
            isLoading: false,
          }),
        ),
    );
  };

  const updatePerson = (id: string, updateStatus?: boolean): void => {
    const endpoint = `persons/${id}`;
    const fullName =
      personalInfo.secondName === ''
        ? `${personalInfo.firstName} ${personalInfo.firstLastname} ${personalInfo.secondLastname}`
        : `${personalInfo.firstName} ${personalInfo.secondName} ${personalInfo.firstLastname} ${personalInfo.secondLastname}`;
    const birthDate = personalInfo.birthDate.split('/');
    const parsedDate = `${birthDate[2]}-${birthDate[1]}-${birthDate[0]}`;

    const payload: PersonProperties = {
      mainDocument: {
        type: 'RFC',
        code: personalInfo.rfc,
      },
      fullName: fullName,
      additionalProperties: {
        firstName: personalInfo.firstName,
        lastName: personalInfo.firstLastname,
        secondLastName: personalInfo.secondLastname,
      },
      birthDate: parsedDate,
      nationality: 'MX',
      contacts: [
        {
          channel: 'PHONE',
          code: `+52${personalInfo.phone.replace(/-/g, '')}`,
          type: 'PERSONAL',
        },
        {
          channel: 'EMAIL',
          code: personalInfo.email,
          type: 'COMERCIAL',
        },
      ],
    };
    if (personalInfo.secondName !== '')
      payload.additionalProperties['secondName'] = personalInfo.secondName;
    dispatch(
      fetchRequests({
        isLoading: true,
      }),
    );
    makeRequests(
      endpoint,
      'POST',
      payload,
      () => {
        if (updateStatus) {
          updateLeadStatus(id);
        } else {
          dispatch(
            fetchSuccess({
              isLoading: false,
            }),
          );
          callback();
        }
      },
      () => {
        dispatch(
          fetchFailure({
            isLoading: false,
          }),
        );
      },
    );
  };

  const createLead = (): void => {
    const endpoint = 'leads';
    const fullName =
      personalInfo.secondName === ''
        ? `${personalInfo.firstName} ${personalInfo.firstLastname} ${personalInfo.secondLastname}`
        : `${personalInfo.firstName} ${personalInfo.secondName} ${personalInfo.firstLastname} ${personalInfo.secondLastname}`;
    const birthDate = personalInfo.birthDate.split('/');
    const parsedDate = `${birthDate[2]}-${birthDate[1]}-${birthDate[0]}`;
    const date = Date.parse(parsedDate);

    const payload: LeadProperties = {
      productType: 'HOMEACQ',
      status: 'CHS_PERSON_COMPLETED',
      personFullName: fullName,
      email: personalInfo.email,
      phone: `+52${personalInfo.phone.replace(/-/g, '')}`,
      installmentTerm: 10,
      birthdate: date,
    };
    queryParams.forEach((value: string, key: string) => {
      switch (key) {
        case 'amount':
          payload['loanAmount'] = value;
          break;
        case 'email':
        case 'phone':
        case 'session':
        case 'notes':
          payload['loanUse'] = value;
          break;
        default:
          payload['reference'] = {
            ...payload.reference,
            [key]: value,
          };
          break;
      }
    });
    makeRequests(
      endpoint,
      'POST',
      payload,
      (response: AxiosResponse) => {
        if (leadId === null) localStorage.setItem('lead_id', response.data.id);
        updatePerson(response.data.id);
      },
      () => {
        dispatch(
          fetchFailure({
            isLoading: false,
          }),
        );
      },
    );
  };

  if (leadId === null) {
    createLead();
  } else {
    updatePerson(leadId, true);
  }
};

export default SavePerson;
